import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import "../styles/main.scss";
import Work from "./Work";
import Contact from "./Contact";
import PhotoViewer from './PhotoViewer';
import { GalleryImage } from './images';
import Logo from '../assets/images/logo.jpg';

export interface SectionProps {
    handleImgClick: (img: GalleryImage) => void;
}

const Landing = () => {
    const { t } = useTranslation();
    const [clickedImg, setClickedImg] = useState<GalleryImage | null>(null);

    const handleImgClick = (img: GalleryImage) => {
        setClickedImg(img);
    }

    const handleClosePhotoViewer = () => {
        setClickedImg(null);
    }

    const servicesNeedsRaw = t('servicesNeeds', { returnObjects: true });
    const servicesNeeds = Array.isArray(servicesNeedsRaw) ? servicesNeedsRaw as string[] : [];

    return (
        <section className='landing'>
            <main className='landing__main'>
                <img className='landing__main-logo' src={Logo} alt={t('logoAlt')} />
                <h1 className='landing__main-heading'>{t('heroHeading')}</h1>
                <div className='landing__main-bio'>
                    <p>{t('bioParagraph1')}</p>
                    <p>{t('servicesIntro')}</p>
                    <ul className='landing__main-services-list'>
                        {servicesNeeds.map((need, i) => (
                            <li key={i}>{need}</li>
                        ))}
                    </ul>
                    <p>{t('availability')}</p>
                    <p>{t('approach')}</p>
                    <p>
                        {t('ctaPrefix')}
                        <a className='landing__main-cta-link' href="#contact">{t('ctaLinkText')}</a>
                    </p>
                </div>
                <Work handleImgClick={handleImgClick} />
                <Contact />
            </main>
            {clickedImg &&
                <PhotoViewer
                    img={clickedImg}
                    handleClosePhotoViewer={handleClosePhotoViewer}
                />
            }
        </section>
    )
}

export default Landing;
